// Mulberry32 — deterministic PRNG from a 32-bit seed
function mulberry32(seed) {
  return function() {
    seed |= 0;
    seed = seed + 0x6D2B79F5 | 0;
    let t = Math.imul(seed ^ seed >>> 15, 1 | seed);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}

// Convert a date string like "2026-03-22" to a numeric seed
function dateToSeed(dateStr) {
  let hash = 0;
  for (let i = 0; i < dateStr.length; i++) {
    hash = ((hash << 5) - hash + dateStr.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

// Get today's date as YYYY-MM-DD
export function getTodayDate() {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}

// Create a seeded RNG from today's date
export function createDailyRng(dateStr) {
  return mulberry32(dateToSeed(dateStr));
}

// Generate daily challenge config from date
export function getDailyChallengeConfig(dateStr) {
  const rng = createDailyRng(dateStr + '_config');

  const difficulties = ['easy', 'normal', 'hard'];
  const playerCounts = [2, 3, 4];
  const handSizes = [3, 4, 5];

  return {
    date: dateStr,
    difficulty: difficulties[Math.floor(rng() * difficulties.length)],
    playerCount: playerCounts[Math.floor(rng() * playerCounts.length)],
    cardsPerHand: handSizes[Math.floor(rng() * handSizes.length)],
  };
}

// Shuffle a deck using seeded RNG
export function seededShuffle(deck, rng) {
  const shuffled = [...deck];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
